module.exports = __webpack_public_path__ + "static/media/zoom-logo.c92a149c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zoom-logo.png
// module id = 1210
// module chunks = 0